
define('text!templates/layouts/layout-app.html',[],function () { return '<div id="menu" class="column"></div>\n<div id="menu-drawer" class="column"></div>\n<div id="content-section" class="column"></div>\n';});

